/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Tab_ToolsInputs */

const en_ui_labs_tab_tools = /** @type {(inputs: Ui_Labs_Tab_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools`)
};

const de_ui_labs_tab_tools = /** @type {(inputs: Ui_Labs_Tab_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools`)
};

/**
* | output |
* | --- |
* | "Tools" |
*
* @param {Ui_Labs_Tab_ToolsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_tab_tools = /** @type {((inputs?: Ui_Labs_Tab_ToolsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Tab_ToolsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_tab_tools(inputs)
	return de_ui_labs_tab_tools(inputs)
});